import { FC, Suspense } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { ErrorBoundaryFallback } from '../errors';

export const OutletRoute: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
};
